import React from 'react';
import BaseTable from './BaseTable';
import MultiInputTableBody from './tbody/MultiInputTableBody';

interface Header {
  label: string;
  sortable: boolean;
  sortKey: string;
  width: string;
}

/** 構造的Ref（非推奨型は使わない） */
type DivRef = { current: HTMLDivElement | null };

interface MultiInputTableProps<T> {
  headers: ReadonlyArray<Header>;
  items: T[];
  keyField: keyof T;
  rowTitleField: keyof T;
  rowTitleSubfield?: keyof T;
  textField?: string[];
  dataField: keyof T;
  onChange: (id: number, field: string, value: string) => void;

  /** 表全体の横スクロール要素を親から参照するための ref */
  scrollContainerRef?: DivRef;
  headerRef?: React.RefObject<HTMLDivElement | null>; // 高さ計算用
  footerRef?: React.RefObject<HTMLDivElement | null>; // 高さ計算用
}

const MultiInputTable = <T,>({
  headers,
  items,
  keyField,
  rowTitleField,
  dataField,
  rowTitleSubfield,
  textField = [],
  onChange,
  scrollContainerRef,
  headerRef,
  footerRef,
}: MultiInputTableProps<T>) => {
  return (
    // 横スクロールはこのラッパにだけ付与（ヘッダーは SyncedScrollHeader で追従）
    <div
      className="multi-input-table-scroll"
      style={{ overflowX: 'auto', maxWidth: '100%' }}
      ref={scrollContainerRef as unknown as React.Ref<HTMLDivElement>}
    >
      <BaseTable headers={headers} headerRef={headerRef} footerRef={footerRef}>
        <MultiInputTableBody<T>
          items={items}
          keyField={keyField}
          rowTitleField={rowTitleField}
          rowTitleSubfield={rowTitleSubfield}
          textField={textField}
          dataField={dataField}
          onChange={onChange}
        />
      </BaseTable>
    </div>
  );
};

export default MultiInputTable;
